(function () {
  if (window.__duetteDrawerClose) return;
  window.__duetteDrawerClose = true;
  var CLOSE_DELAY = 550;

  function getDrawer() { return document.getElementById('NavDrawer'); }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer) return;
    var closeBtn = drawer.querySelector('.js-drawer-close');
    if (closeBtn) closeBtn.click();
  }

  function drawerIsOnScreen() {
    var drawer = getDrawer();
    if (!drawer) return false;
    var r = drawer.getBoundingClientRect();
    return r.width > 0 && r.right > 5 && r.left < window.innerWidth - 5;
  }

  function headerOffset() {
    var header = document.querySelector('.site-header');
    return (header ? header.offsetHeight : 70) + 12;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('#NavDrawer a[href]') : null;
    if (!link) return;
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (link.target.toLowerCase() === '_blank') return;

    var url;
    try { url = new URL(link.href, window.location.href); } catch (err) { return; }

    var isSamePageAnchor = url.hash &&
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname &&
      url.search === window.location.search;

    var target = null;
    if (isSamePageAnchor) {
      try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (err) { target = null; }
    }

    if (target) {
      e.preventDefault();
      closeDrawer();
      window.setTimeout(function () {
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
        window.scrollTo({ top: Math.max(top, 0), behavior: prefersReducedMotion() ? 'instant' : 'smooth' });
        if (window.history && window.history.replaceState) window.history.replaceState(window.history.state, '', url.hash);
      }, CLOSE_DELAY);
    } else {
      closeDrawer();
    }
  }, true);

  window.addEventListener('pageshow', function (e) {
    if (e.persisted && drawerIsOnScreen()) closeDrawer();
  });
})();
